export enum MapSignsIcons {
  SPEED_LIMIT = 'SPEED_LIMIT',
  SPEED_LIMIT_END = 'SPEED_LIMIT_END',
  SPEED_LIMIT_ZONE = 'SPEED_LIMIT_ZONE',
  SPEED_LIMIT_ZONE_END = 'SPEED_LIMIT_ZONE_END',
  ALL_RESTRICTIONS_END = 'ALL_RESTRICTIONS_END',
  CITY_START = 'CITY_START',
  CITY_END = 'CITY_END',
  HIGHWAY = 'HIGHWAY',
  HIGHWAY_END = 'HIGHWAY_END',
  MOTORWAY = 'MOTORWAY',
  MOTORWAY_END = 'MOTORWAY_END',
  TRAFFIC_CALMING = 'TRAFFIC_CALMING',
  TRAFFIC_CALMING_END = 'TRAFFIC_CALMING_END',
  YIELD = 'YIELD',
  UNKNOWN = 'UNKNOWN_TYPE',
}

export const MapClusterIcons = {
  TSC: 'TRAFFIC_SIGN_CLUSTER',
}

export const MapIcons = {
  CS: 'CONSTRUCTION',
  ARROW_LEFT: 'arrow-left',
  ARROW_BOTH: 'arrows-left-right',
}

export const MapSupsIcons = {
  SUP_UNKNOWN: 'UNKNOWN_TYPE',
  SUP_UNKNOWN_1: 'UNKNOWN_TYPE_1',
  SUP_UNKNOWN_2: 'UNKNOWN_TYPE_2',
  SUP_UNKNOWN_3: 'UNKNOWN_TYPE_3',
  SUP_UNKNOWN_4: 'UNKNOWN_TYPE_4',
  SUP_UNKNOWN_5: 'UNKNOWN_TYPE_5',
  SUP_ALL_WAY: 'SUP_ALL_WAY',
  SUP_ELECTRONIC_CAR: 'SUP_ELECTRONIC_CAR',
  SUP_FOG: 'SUP_FOG',
  SUP_HAZMAT: 'SUP_HAZMAT',
  SUP_MOTORCYCLE: 'SUP_MOTORCYCLE',
  SUP_OIL_TRAIL: 'SUP_OIL_TRAIL',
  SUP_PASSENGER_CAR_WITH_TAILER: 'SUP_PASSENGER_CAR_WITH_TAILER',
  SUP_PASSENGER_CAR: 'SUP_PASSENGER_CAR',
  SUP_PEDESTRIAN: 'SUP_PEDESTRIAN',
  SUP_ROAD_DAMAGE: 'SUP_ROAD_DAMAGE',
  SUP_SCHOOL: 'SUP_SCHOOL',
  SUP_SNOW: 'SUP_SNOW',
  SUP_SNOW_OR_RAIN: 'SUP_SNOW_OR_RAIN',
  SUP_TIME: 'SUP_TIME',
  SUP_TRAFFIC_JAM: 'SUP_TRAFFIC_JAM',
  SUP_TRAIN: 'SUP_TRAIN',
  SUP_TRAM: 'SUP_TRAM',
  SUP_TRUCK_WITH_TRAILER: 'SUP_TRUCK_WITH_TRAILER',
  SUP_TRUCK: 'SUP_TRUCK',
  SUP_WEIGHT: 'SUP_WEIGHT',
  SUP_WET: 'SUP_WET',
  SUP_HAZMAT_WET: 'SUP_HAZMAT_WET',
  SUP_MISC_INFO: 'SUP_MISC_INFO', // Maps to unknown (empty sign)
  SUP_MISC_RESTRICTION: 'SUP_MISC_RESTRICTION', // Maps to unknown (empty sign)
  SUP_BUS: 'SUP_BUS',
  SUP_TANK: 'SUP_TANK',
  SUP_TAXI: 'SUP_TAXI',
  SUP_IN_LEFT_DIRECTION: 'SUP_IN_LEFT_DIRECTION',
  SUP_IN_RIGHT_DIRECTION: 'SUP_IN_RIGHT_DIRECTION',
  SUP_RAMP: 'SUP_RAMP',
  SUP_STARTED_IN: 'SUP_STARTED_IN',
  SUP_VALID_FOR: 'SUP_VALID_FOR',
}
